/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const marketTierRowDtoSchema = z.object({
  tier: z.optional(z.string()),
  typesOfInvestors: z.optional(z.string()),
  numberOfInvestors: z.optional(z.string()),
  estValue: z.optional(z.string()),
});
